export const mustBeContentType =
  (acceptedFileType: string, fieldName: string, message?: string) =>
  (value: any, allValues: any) => {
    const type = allValues[`${fieldName}-filetype`];
    if (!type) {
      return undefined;
    }

    const isAccepted = acceptedFileType.includes(type);

    const msg = message || 'Le format du fichier n’est pas valide.';
    return isAccepted ? undefined : msg;
  };
